export const open_pick_point = 'open_pick_point';

export function openPickPoint(open) {
    return {
        type: open_pick_point,
        data: open,
    };
}
